Jelly.Payments.Select_Gift = function(Parameters) {

	// Get gift anchor
	$Gift_Anchor = $("#" + Parameters["Namespace"] + " .Gift_Anchor[data-id=\"" + Parameters["Gift"] + "\"]");

	// Determine if selected
	var Is_Selected = $Gift_Anchor.parent().hasClass("Selected");

	// Set selected class

	$Gift_Anchor.parent().toggleClass("Selected");

	// Add/remove input

	if (!Is_Selected) {
		Jelly.Actions.Add_Hidden_Value({
			"Namespace": Parameters["Namespace"],
			"Input_Alias": "Gift_" + Parameters["Gift"],
			"Value": 1
		});		
	}
	else {
		Jelly.Actions.Add_Hidden_Value({
			"Namespace": Parameters["Namespace"],
			"Input_Alias": "Gift_" + Parameters["Gift"],
			"Value": 0
		});		
	}

	// Calculate total

	var Gift_Total = 0;
	$("#" + Parameters["Namespace"] + " .Gift_Anchor").each(function () {
		if ($(this).parent().hasClass("Selected")){
			Gift_Total += $(this).data("amount");
		}
	});

	// Update donate box behavior

	var $Payment_Input = $("#" + Parameters["Namespace"] + " .Payment .Input input");
	$Payment_Input.attr("min", Gift_Total);

	// Update donate box amount if lower than gift total, or not touched

	if ($Payment_Input.val() <  Gift_Total || !$Payment_Input.data("touched")) {
		$Payment_Input
			.val(Gift_Total)
			.data("touched", false)
			.change();
	}
};